var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"mini"}},_vm._l((_vm.form.floors),function(floor,index){return _c('el-form-item',{key:floor.key,attrs:{"label":_vm.$t('text.number_of_rooms') +
        ' (' +
        _vm.$t('text.floor') +
        ' ' +
        (index + 1) +
        ')',"prop":'floors.' + index + '.numberOfRooms',"rules":{
      required: true,
      message: _vm.$t('text.please_enter_number_of_rooms'),
      trigger: 'blur'
    }}},[_c('el-input-number',{staticClass:"wp-100",attrs:{"min":1,"step-strictly":""},model:{value:(floor.numberOfRooms),callback:function ($$v) {_vm.$set(floor, "numberOfRooms", $$v)},expression:"floor.numberOfRooms"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }